import { useEffect } from 'react';
import { useNavigate, useParams, Navigate } from 'react-router-dom';
import ProfilePanel from '../components/ProfilePanel';
import { useAppContext } from '../context/AppContext';
import { ROUTES } from '../navigation';

function OrderTrackingPage() {
  const navigate = useNavigate();
  const { orderId } = useParams();
  const {
    currentUser,
    cartQty,
    trackingOrderId,
    setTrackingOrderId,
    handleLogout,
  } = useAppContext();

  // Set tracking order ID from URL param
  useEffect(() => {
    if (orderId) {
      setTrackingOrderId(orderId);
    }
  }, [orderId, setTrackingOrderId]);

  if (!currentUser) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return (
    <ProfilePanel
      user={currentUser}
      onClose={() => navigate(ROUTES.HOME)}
      initialTab="orders"
      trackingOrderId={orderId || trackingOrderId}
      onOpenCart={() => navigate(ROUTES.CART)}
      cartCount={cartQty}
      onClearTrackingId={() => {
        setTrackingOrderId(null);
        navigate(ROUTES.ORDERS);
      }}
      onHelp={() => navigate(ROUTES.HELP)}
      onLogout={handleLogout}
      onAddressPickerChange={() => {}}
    />
  );
}

export default OrderTrackingPage;
